export default __webpack_public_path__ + "static/media/liveOak.2b6d6cc8.png";